<template>
  <img :src="src"/>
</template>

<script>
export default {
  name: "Img",
  props: {
    asset: String,
  },
  computed: {
    src() {
      return require("@/assets/" + this.asset);
    }
  }
}
</script>

<style scoped>
img {
  width: 100%;
}
</style>